import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CommonService from "../../services/common.service";
import { API_URLS } from "../../constants/api-urls";
import "./QAPaymentSuccess.scss";

export default function QAPaymentSuccess() {
  const { inspectionId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [inspection, setInspection] = useState(null);

  useEffect(() => {
    if (!inspectionId) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    CommonService.get(API_URLS.QA.INSPECTION_BY_ID(inspectionId))
      .then((res) => {
        if (!cancelled) setInspection(res?.data ?? null);
      })
      .catch(() => {
        if (!cancelled) setInspection(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [inspectionId]);

  const workOrderId = inspectionId
    ? `WO-${inspectionId}-${new Date().getFullYear()}`
    : "—";

  const formatTimeline = () => {
    if (!inspection?.inspection_date) return "—";
    const start = new Date(inspection.inspection_date);
    const end = inspection.proposed_end_date
      ? new Date(inspection.proposed_end_date)
      : new Date(start);
    if (!inspection.proposed_end_date) end.setDate(end.getDate() + 3);
    const fmt = (d) => d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
    return `${fmt(start)} – ${fmt(end)}`;
  };

  const handleTrackProgress = () => {
    navigate("/buyer/qa-quotations-list", { state: { paymentSuccess: true } });
  };

  if (loading) {
    return (
      <div className="qa-payment-success-page">
        <div className="qa-payment-success-container">
          <div className="qa-payment-success-loading">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="qa-payment-success-page">
      <div className="qa-payment-success-container">
        <div className="qa-payment-success-icon" aria-hidden>
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
        <h1 className="qa-payment-success-title">Payment Success</h1>

        <div className="qa-payment-success-card">
          <div className="qa-payment-success-card-row">
            <div className="qa-payment-success-field">
              <span className="qa-payment-success-label">Work order ID</span>
              <span className="qa-payment-success-value">{workOrderId}</span>
            </div>
            <div className="qa-payment-success-field">
              <span className="qa-payment-success-label">Inspection timeline</span>
              <span className="qa-payment-success-value">{formatTimeline()}</span>
            </div>
          </div>
          <button
            type="button"
            className="qa-payment-success-btn"
            onClick={handleTrackProgress}
          >
            Track inspection progress
          </button>
        </div>
      </div>
    </div>
  );
}
